<ng-container *ngIf="worksheets$ | withLoading | async as worksheets">
  @if (loading$ | async) {
    <div class="loading-wrapper mt-4">
      <div class="w-100">
        <fgbcl-loading></fgbcl-loading>
      </div>
    </div>
  } @else {
    <ng-container *ngIf="worksheets.data">
      @if (hasItems) {
        <fgb-video-gallery [videos]="worksheets.data" />

        <div class="container">
          <h2 class="card-header fw-bold border-0 px-2 pb-0">
            {{ 'worksheet.title' | translate }}
          </h2>
          <div *ngFor="let worksheetGroup of worksheets.data">
            <div [class.row]="isList">
              <ng-container *ngFor="let item of worksheetGroup.Items">
                <ng-container *ngIf="item.WorksheetType == worksheetTypes.Download">
                  <div [class.col-lg-4]="isList">
                    <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item>
                  </div>
                </ng-container>

                <ng-container *ngIf="item.WorksheetType == worksheetTypes.Gallery">
                  <div [class.col-lg-4]="isList">
                    <fgb-worksheet-item
                      [worksheetItem]="item"
                      [worksheetId]="worksheetGroup.WorksheetId"
                    ></fgb-worksheet-item></div
                ></ng-container>

                <ng-container *ngIf="item.WorksheetType == worksheetTypes.Link">
                  <div [class.col-lg-4]="isList">
                    <fgb-worksheet-item
                      [worksheetItem]="item"
                      [worksheetId]="worksheetGroup.WorksheetId"
                    ></fgb-worksheet-item></div
                ></ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      } @else {
        <div class="container">
          <ng-container *ngTemplateOutlet="noWorksheets"></ng-container>
        </div>
      }
    </ng-container>
  }

  <!-- No Data available -->
  <ng-container *ngIf="worksheets.isEmpty"> <p>No worksheet available</p></ng-container>

  <!-- Error -->
  <ng-container *ngIf="worksheets.error">
    <p>Error {{ worksheets.error }}</p>
  </ng-container>

  <!-- Loading -->
  <ng-container *ngIf="worksheets.isLoading">
    <div class="w-100">
      <fgbcl-loading></fgbcl-loading>
    </div>
  </ng-container>
</ng-container>

<!-- No results -->
<ng-template #noWorksheets>
  <div class="worksheet-placholder mt-4">
    <div class="no-items no-results-placeholder-div">
      <div
        class="svg svg-info vs-svg ms-auto me-auto"
        fgbAnimateSvg
        [inlineSVG]="'assets/images/placeholders/GalleryPlaceholder.svg'"
      ></div>
      <div class="no-results-placeholder">{{ 'worksheet.placeholder.description' | translate }}</div>
    </div>
  </div>
</ng-template>
